<template>
    <div> 
        <loader-component v-if="isSendingDataToServer"></loader-component>
        <loader-component v-if="showLoader"></loader-component>
        <div v-else class="wrapper default shopping-page">

            <!-- header -->
            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
                <navbar-component></navbar-component>
            </header>
            <!-- header -->
            <!-- header-shopping -->
            <!-- main-shopping -->
            <main class="cart-page default">
                <div class="container">
                    <div class="row">

                        <div class="cart-page-content col-xl-12 col-lg-12 col-md-12 ">
                            <div class="row">
                                <div class="info-main-top col-xl-6 col-lg-6 col-md-6 col-xs-12">
                                    <span class="title">شماره سفارش : </span>
                                    <span class="text"> {{order.InvoiceNo}} </span>
                                </div>
                                <div class="info-main-top col-xl-6 col-lg-6 col-md-6 col-xs-12">
                                    <span class="title"> تاریخ و زمان ثبت : </span>
                                    <span class="text"> {{order.OrderRegDateTime}} </span>
                                </div>
                            </div>
                            <hr />

                            <section class="page-content tracking default col-xl-12 col-lg-12 col-md-12">
                                <div class="content-p col-xl-12 col-lg-12 col-md-12">
                                    <div class="title-showInvoice  col-md-4">
                                        <p class="title">وضیعت سفارش</p>
                                    </div>
                                    <ul v-if="order.LastOrderStatusTypeId != 3">
                                        <li :class="['step1','left-l',(order.LastOrderStatusTypeId >= 1)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">بررسی سفارش</span>
                                        </li>
                                        <li :class="['progress',(order.LastOrderStatusTypeId >= 2)? 'done':'']">
                                        </li>
                                        <li :class="['step2','right-r',(order.LastOrderStatusTypeId >= 2)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">تایید سفارش</span>
                                        </li>
                                        <li :class="['progress','left-l',(order.LastOrderStatusTypeId >= 4)? 'done':'']">
                                        </li>
                                        <li :class="['step4','left-l',(order.LastOrderStatusTypeId >= 4)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">تحویل به پیک</span>
                                        </li>
                                        <li :class="['progress',(order.LastOrderStatusTypeId >= 5)? 'done':'']">
                                        </li>
                                        <li :class="['step3','right-r',(order.LastOrderStatusTypeId >= 5)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">تحویل به مشتری</span>
                                        </li>

                                    </ul>
                                    <ul v-else>
                                        <li style="width:100%">
                                            <div class="warning-checkout text-center default col-xl-12 col-lg-12 col-md-12">
                                                <div class="icon-warning">
                                                    <img src="/assets/img/step/rejectOrder.svg" alt="سفارش شما توسط فروشگاه رد شده است" title="سفارش شما توسط فروشگاه رد شده است" />
                                                </div>
                                                <h1>سفارش شما توسط فروشگاه رد شده است.</h1>
                                                <p></p>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="preparreduration-main" v-if="order.PrepareDuration != null && order.LastOrderStatusTypeId != 5 && order.LastOrderStatusTypeId != 1">
                                        <div class="content"><span class="title">زمان تقریبی تحویل سفارش :</span> <span> {{order.PrepareDuration}}</span> <span></span></div>
                                    </div>
                                    <div class="preparreduration-main" v-if="order.LastOrderStatusTypeId == 1">
                                        <div class="content"><span class="title">سفارش ثبت و در حال بررسی می باشد.</span></div>
                                    </div>
                                    <div class="preparreduration-main" v-if="order.LastOrderStatusTypeId == 5">
                                        <div class="content"><span class="title">سفارش شما تحویل داده شده است.</span></div>
                                    </div>
                                </div>
                            </section>
                            <section class="table-content col-xl-12 col-lg-12 col-md-12">
                                <div class="toman"><i class="now-ui-icons travel_info"></i> <span class="alarm"> توجه : </span> <span>  قیمت ها به تومان می باشد.</span></div>
                                <div class="table-responsive">
                                    <table class="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">ردیف</th>
                                                <th scope="col">نام محصول</th>
                                                <th scope="col">واحد</th>
                                                <th scope="col">تعداد / مقدار</th>
                                                <th scope="col">قیمت واحد</th>
                                                <th scope="col">قیمت کل</th>
                                                <th scope="col">مبلغ تخفیف</th>
                                                <th scope="col">قیمت نهایی</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(orderDetails ,index) in order.OrderDetails">
                                                <th scope="row">{{index + 1}}</th>
                                                <td>{{orderDetails.ProductName}}</td>
                                                <td>{{orderDetails.ProductUnit}}</td>
                                                <td>{{orderDetails.Quantity}}</td>
                                                <td>{{orderDetails.Price | formatNumber}}</td>
                                                <td>{{orderDetails.Quantity * orderDetails.Price | formatNumber}}</td>
                                                <td>{{(orderDetails.Quantity * orderDetails.Price) - orderDetails.FinalPriceSum | formatNumber}}</td>
                                                <td>{{orderDetails.FinalPriceSum | formatNumber}}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </section>
                            <hr />
                            <section class="cart-summery col-xl-12 col-lg-12 col-md-12">
                                <div class="row main-cartsummery">
                                    <div class="info-main-b col-xl-4 col-lg-4 col-md-4 col-xs-12">
                                        <span class="title">تعداد محصول : </span>
                                        <span class="text"> {{order.CountOfProducts}} عدد</span>
                                    </div>
                                    <div class="info-main-b col-xl-4 col-lg-4 col-md-4 offset-md-4 col-xs-12">
                                        <span class="title"> قیمت کل محصولات : </span>
                                        <span class="text"> {{order.SubTotal | formatNumber }} تومان</span>
                                    </div>
                                    <div class="info-main-b col-xl-4 col-lg-4 col-md-6 col-xs-12">
                                        <span class="title"> جمع مبلغ تخفیف : </span>
                                        <span class="text"> {{order.Discount | formatNumber }} تومان</span>
                                    </div>
                                    <div class="info-main-b col-xl-4 col-lg-4 col-md-6 col-xs-12">
                                        <span class="title">  مبلغ کد تخفیف : </span>
                                        <span class="text"> {{order.CouponDiscount | formatNumber }} تومان</span>
                                    </div>
                                    <div class="info-main-b col-xl-4 col-lg-4 col-md-6 col-xs-12">
                                        <span class="title">  جمع سود شما از تخفیف : </span>
                                        <span class="text"> {{order.Discount + order.CouponDiscount | formatNumber }} تومان</span>
                                    </div>
                                    <div class="info-main-b col-xl-4 col-lg-4 col-md-6 col-xs-12">
                                        <span class="title">  مالیات بر ارزش افزوده : </span>
                                        <span class="text"> {{order.Tax | formatNumber }} ({{order.TaxRate}}%) تومان</span>
                                    </div>
                                    <div class="info-main-b col-xl-4 col-lg-4 col-md-6 col-xs-12">
                                        <span class="title"> هزینه ارسال : </span>
                                        <span class="text"> {{order.DeliveryFee | formatNumber }} تومان</span>
                                    </div>
                                    <div class="info-main-b col-xl-4 col-lg-4 col-md-6 col-xs-12">
                                        <span class="title">  مبلغ قابل پرداخت : </span>
                                        <span class="text"> {{order.InvoiceDue | formatNumber }} تومان</span>
                                    </div>
                                    <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <span class="title">  نحوه ارسال : </span>
                                        <span class="text"> {{order.CarrierName }} </span>
                                    </div>
                                    <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <span class="title">  آدرس محل تحویل : </span>
                                        <span class="text"> {{order.DeliveryAddress }} </span>
                                    </div>
                                    <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <span class="title">  شماره تماس تحویل گیرنده : </span>
                                        <span class="text"> {{order.TransfereeMobNo }} </span>
                                    </div>
                                    <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <span class="title">  کد رهگیری پستی : </span>
                                        <span class="text"> {{order.PostalTrackingCode }} </span>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>

            </main>
            <!-- main-shopping -->
            <!-- footer -->
            <footer-component></footer-component>
            <!-- footer -->
        </div>
    </div>
</template>

<script>
    import { initialSite } from "../../module/initialSite"
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                order: {},
                showLoader: false,
                isSendingDataToServer: false,
            }
        },

        beforeMount() {
            createPageTitle('وضیعت سفارش');
            initialSite(this);
            this.isSendingDataToServer = true;
            httpPromise(this, '/v1/Orders/Orders/Read', 'Get', { HashOrderId: this.$route.params.hashOrderId },
                response => {
                    toastr.remove();
                    this.order = response.data.Value;
                    this.isSendingDataToServer = false;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);
                    this.isSendingDataToServer = false;
                }
            );
        }
    }
</script>
<style scoped>
    .title-showInvoice {
        margin-bottom: 50px;
    }

    .preparreduration-main .content {
        display: inline-block;
        padding: 7px 25px 7px 25px;
        border: 1px solid #ddd;
        border-radius: 7px;
        margin-top: 25px;
        margin-bottom: 30px;
    }

    .preparreduration-text {
    }

    .alarm {
        font-size: 17px;
    }

    .toman {
        text-align: center;
        margin-bottom: 7px;
    }

        .toman i {
            vertical-align: middle;
            font-size: 17px;
        }

    .main-cartsummery {
        border: 1px solid #ddd;
        border-radius: 7px;
        margin-bottom: 25px;
        padding: 15px
    }

    .info-main-b {
        padding: 10px;
    }

        .info-main-b .text {
            color: #888;
        }

        .info-main-b .title {
            color: #666;
            font-size: 15px;
        }

    .info-main-top .text {
        color: #888;
    }

    .title-showInvoice {
        padding-right: 15px;
    }

    .info-main-top {
        padding: 25px;
        text-align: center;
    }

    .table thead tr {
        background-color: #85b3be;
        border: 1px solid #85b3be;
        color: #fff;
    }

    .shopping-page header.header-shopping .checkout-steps li a {
        display: inline-block;
        height: 39px;
    }

    .cart-page .checkout-aside {
        margin-top: 20px;
        margin-bottom: 83px;
        background-color: #fff;
    }

    .cart-page-content {
        background-color: #fff;
        margin-top: 20px;
    }

    .content-p {
        text-align: center;
    }

    .done {
    }

    .step1 {
    }

    .tracking {
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .tracking ul li .icon {
            display: block;
            height: 50px;
            width: 70px;
            margin: 0 auto;
            position: relative;
            padding: 0 10px;
            z-index: 100;
        }

        .tracking ul li {
            display: inline-table;
            width: 12%;
            position: relative;
            z-index: 1;
        }

            .tracking ul li.progress {
                border-top: 2px solid #cecece;
                border-top-color: rgb(206, 206, 206);
                border-radius: 0;
                background-color: #fff;
                height: 35px;
                width: 10%;
                margin-top: 30px;
            }

                .tracking ul li.progress.done {
                    border-color: #12b65c;
                }

            .tracking ul li.step1.done .icon {
                background: #fff url("/assets/img/step/track-step1h.svg") no-repeat center center;
            }

            .tracking ul li.step1 .icon {
                background: #fff url("/assets/img/step/track-step1.svg") no-repeat center center;
            }

            .tracking ul li.step2.done .icon {
                background: #fff url("/assets/img/step/track-step2h.svg") no-repeat center center;
            }

            .tracking ul li.step2 .icon {
                background: #fff url("/assets/img/step/track-step2.svg") no-repeat center center;
            }

            .tracking ul li.step3.done .icon {
                background: #fff url("/assets/img/step/track-step3h.svg") no-repeat center center;
            }

            .tracking ul li.step3 .icon {
                background: #fff url("/assets/img/step/track-step3.svg") no-repeat center center;
            }

            .tracking ul li.step4.done .icon {
                background: #fff url("/assets/img/step/track-step4h.svg") no-repeat center center;
            }

            .tracking ul li.step4 .icon {
                background: #fff url("/assets/img/step/track-step4.svg") no-repeat center center;
            }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .success-checkout h1, .warning-checkout h1, .preparreduration-main .content {
            font-size: 12px;
        }

        .shopping-page header.header-shopping .checkout-steps li a.active::after {
            bottom: -23px;
        }

        .tracking ul li.progress {
            display: none;
            visibility: hidden;
        }

        .right-r {
            padding-right: 20px;
        }

        .left-l {
            padding-left: 20px;
        }

        .tracking {
            margin-top: 65px;
            margin-bottom: 70px;
        }
    }
</style>